// src/pages/UsersPage.jsx
import React, { useState } from "react";
import { Radio } from "antd";
import {TableUsers} from "../index";
import ShiftEventsTable from "./ShiftEventsTable";

const UsersPage = ({ invite, websocket, c, ds, query }) => {
  const [viewMode, setViewMode] = useState("users");

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Radio.Group
          value={viewMode}
          onChange={(e) => setViewMode(e.target.value)}
          optionType="button"
        >
          <Radio.Button value="users">Пользователи</Radio.Button>
          <Radio.Button value="events">События смен</Radio.Button>
        </Radio.Group>
      </div>

      {viewMode === "users" ? (
        <TableUsers
          c={c}
          ds={ds}
          query={query}
          invite={invite}
          websocket={websocket}
        />
      ) : (
        <ShiftEventsTable websocket={websocket} />
      )}
    </div>
  );
};

export default UsersPage;